import type { InputOf } from '@elara/firebolt/shared';

import { z } from 'zod';

import { ResourceMetaSchema } from '@elara/core/agent/resources';
import { collectionPath, defineModelSpec, orderBy } from '@elara/firebolt/shared';

import { chatId, chatMessageId, id } from './schemas/zod-types.js';

export const ResourceMetadataSpec = defineModelSpec({
  path: collectionPath`chats/${chatId}/messages/${chatMessageId}/resources/${id}`,
  shape: {
    chatId: z.string().describe('ID of the chat where this resource metadata was captured'),
    messageId: z.string().describe('ID of the message associated with this resource metadata'),
    resourceId: z.string().describe('Stable identifier for the resource entry'),
    provider: z.string().optional().describe('Provider responsible for the resource lookup'),
    resourceType: z.string().optional().describe('Type of the resource (document, group, error, etc.)'),
    status: z.string().optional().describe('Execution status for the resource lookup'),
    toolCallId: z.string().optional().describe('Associated tool call identifier when applicable'),
    agentId: z.string().optional().describe('Agent identifier when the resource came from an agent tool'),
    index: z.number().int().nonnegative().describe('Stable ordering index for resources within the message'),
    meta: ResourceMetaSchema.describe('Full resource metadata payload'),
  },
  constraints: [orderBy('createdAt')],
});

export type ResourceMetadataSpec = typeof ResourceMetadataSpec;
export interface ResourceMetadataInput extends InputOf<ResourceMetadataSpec> {}
